var map = {
	"./b_1.jpg": 1077,
	"./b_2.jpg": 1078,
	"./b_3.jpg": 1079,
	"./b_4.jpg": 1080,
	"./f_1.jpg": 1081,
	"./f_2.jpg": 1082,
	"./f_3.jpg": 1083,
	"./f_4.jpg": 1084,
	"./f_5.jpg": 1085,
	"./h_1.jpg": 1086,
	"./h_2.jpg": 1087,
	"./h_3.jpg": 1088,
	"./h_4.jpg": 1089,
	"./m_1.jpg": 1090,
	"./m_2.jpg": 1091,
	"./p_1.jpg": 1092,
	"./p_2.jpg": 1093,
	"./p_3.jpg": 1094,
	"./p_4.jpg": 1095,
	"./p_5.jpg": 1096,
	"./pro_1.jpg": 1097,
	"./pro_2.jpg": 1098,
	"./pro_3.jpg": 1099,
	"./pro_4.jpg": 1100,
	"./t_1.jpg": 1101,
	"./t_2.jpg": 1102,
	"./t_3.jpg": 1103,
	"./team_1.jpg": 1104,
	"./team_2.jpg": 1105,
	"./team_3.jpg": 1106,
	"./team_4.jpg": 1107,
	"./team_5.jpg": 1108
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1076;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assets-for-demo/sections ^\.\/.*\.jpg$
// module id = 1076
// module chunks = 0